// "Get data from" dialog (Figma "Get data from another entity"): pick the season
// a pre-season takes its data from. Pre season / Active list the farming unit's
// blocks by field, Archive this block's seasons by month (dataSourceGroups).
const React = require('react');
const { useState, useMemo } = require('react');
const { useTranslation } = require('react-i18next');
const {
  SEASON_TABS,
  dataSourceGroups,
  defaultDataSource,
} = require('./seasonHelpers');
const { Modal } = require('./NewSeasonUi');

const TABS = Object.freeze([
  {
    value: SEASON_TABS.PRE_SEASON,
    labelKey: 'new_season_pre_season',
    emptyKey: 'new_season_get_data_no_pre_season',
  },
  {
    value: SEASON_TABS.ACTIVE,
    labelKey: 'new_season_active',
    emptyKey: 'new_season_get_data_no_active',
  },
  {
    value: SEASON_TABS.ARCHIVE,
    labelKey: 'new_season_archive',
    emptyKey: 'new_season_get_data_no_archive',
  },
]);

const optionsOf = (options) =>
  options.map((option) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  ));

const GetDataFromModal = ({ tree, blockId, isLoading, onCancel, onSelect }) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState(SEASON_TABS.PRE_SEASON);
  const groups = useMemo(
    () =>
      dataSourceGroups(tree, tab, blockId, t('new_season_get_data_this_block')),
    [tree, tab, blockId, t],
  );
  // The user's choice per tab; each tab starts on its default.
  const [chosen, setChosen] = useState({});
  const seasonId = chosen[tab] || defaultDataSource(groups, blockId);
  const current = TABS.find((option) => option.value === tab);
  return (
    <Modal
      isOpen
      onClose={isLoading ? () => {} : onCancel}
      className='ns-modal-small'
    >
      <div className='ns-modal-header'>{t('new_season_get_data_from')}</div>
      <div className='ns-modal-body'>
        <div className='ns-get-data-tabs' role='tablist'>
          {TABS.map((option) => (
            <button
              type='button'
              role='tab'
              key={option.value}
              aria-selected={option.value === tab}
              className={
                'ns-get-data-tab' +
                (option.value === tab ? ' ns-get-data-tab-active' : '')
              }
              onClick={() => setTab(option.value)}
            >
              {t(option.labelKey)}
            </button>
          ))}
        </div>
        {groups.length > 0 ? (
          <select
            className='form-control ns-input custom-select'
            aria-label={t('new_season_get_data_from')}
            value={seasonId}
            onChange={(event) =>
              setChosen((previous) => ({
                ...previous,
                [tab]: event.target.value,
              }))
            }
          >
            {groups.map((group) =>
              group.label ? (
                <optgroup key={group.label} label={group.label}>
                  {optionsOf(group.options)}
                </optgroup>
              ) : (
                optionsOf(group.options)
              ),
            )}
          </select>
        ) : (
          <div className='ns-muted'>{t(current.emptyKey)}</div>
        )}
      </div>
      <div className='ns-modal-footer'>
        <button
          type='button'
          className='ns-btn ns-btn-outline'
          disabled={isLoading}
          onClick={onCancel}
        >
          {t('cancel')}
        </button>
        <button
          type='button'
          className='ns-btn ns-btn-primary'
          disabled={isLoading || !seasonId}
          onClick={() => onSelect(seasonId)}
        >
          {t('new_season_select')}
          {isLoading && (
            <span
              className='spinner-border spinner-border-sm ml-2'
              role='status'
            />
          )}
        </button>
      </div>
    </Modal>
  );
};

module.exports = GetDataFromModal;
